<div class="login-section-container">
  <div class="login-section">
    @if (loginStatus()) {
      <div class="login-status">
        <div class="extra-info">{{ loginStatus() }}</div>
      </div>
    } @else if (userName()) {
      <div class="login-user-name">
        <div>Logged in as <strong>{{userName()}}</strong> (<a [href]="null" class="action-link" (click)="logout($event)">Log&nbsp;out</a>)</div>
      </div>
    } @else {
      <a [href]="null" class="action-link" (click)="login($event)">Log in on pathofexile.com</a>
    }
  </div>
</div>

@if (showRealmPicker) {
  <app-realm-selector-dialog (close)="showRealmPicker = false; selectedRealm = $event"></app-realm-selector-dialog>
}
